<ul
  class="operation-filters-header mat-elevated-item w-100 s-p-5 rounded d-flex flex-row flex-wrap s-mb-5 card-shadow"
>
  <li class="w-100 s-mb-3 d-flex">
    <mat-icon class="c-platform-mid"> filter_alt </mat-icon>
    <p class="s-heading-4">
      {{ "filters" | transloco }}
    </p>
  </li>
  <ng-content select="[slot=items]"> </ng-content>
  <li class="d-flex gap-2">
    <div>
      <button
        type="button"
        [matTooltip]="'filter' | transloco"
        class="s-p-2 bg-transparent d-flex border border-clr-background-mid rounded"
        (click)="openFilterDialog()"
      >
        <mat-icon class="c-platform-mid"> filter_alt </mat-icon>
      </button>
    </div>
    <div>
      <button
        *ngIf="showDelete()"
        [matTooltip]="'delete' | transloco"
        type="button"
        class="s-p-2 bg-transparent d-flex border border-clr-red-5 rounded"
        (click)="clearAllFilters()"
      >
        <mat-icon class="c-red-5"> delete </mat-icon>
      </button>
    </div>
  </li>
</ul>
